module.exports = __webpack_public_path__ + "img/test01-6.3a673b65.jpg";